import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import footerLogo from "../../assets/img/Footer.png";
import {
  COMPANY_ADDRESS_LINE,
  COMPANY_FOOTER_LICENSE_LINE,
  COMPANY_INSTAGRAM_HANDLE,
  COMPANY_INSTAGRAM_URL,
  COMPANY_NAME,
  COMPANY_PHONE_DISPLAY,
  COMPANY_PHONE_HREF,
  COMPANY_SERVICE_AREA,
  COMPANY_YELP_URL,
} from "../../constants/company";
import { useLandingModals } from "./landingModalContext";
import { appPath } from "../../utils/appPaths";

const LandingFooter = () => {
  const { openKitchen, openBathroom, openLetsConnect } = useLandingModals();

  return (
    <footer className="rs-landing-footer">
      <div className="footer-top">
        <div className="footer-brand">
          <Link to="/" className="nav-logo nav-logo--footer">
            <img src={footerLogo} alt={COMPANY_NAME} />
          </Link>
          <p>
            We specialize in home remodeling, helping home owners from start to finish. We help with initial
            consultation, design phase, permitting, full service construction, and more.
          </p>
          <p className="footer-service-area">Serving {COMPANY_SERVICE_AREA}.</p>
        </div>
        <div>
          <div className="footer-col-title">Quick Links</div>
          <div className="footer-links">
            <Link to="/ourprojects">Our Projects</Link>
            <Link to="/aboutus">About Us</Link>
            <Link to="/services">Services</Link>
          </div>
        </div>
        <div>
          <div className="footer-col-title">Services</div>
          <div className="footer-links">
            <button type="button" className="footer-text-btn" onClick={openKitchen}>
              Kitchen Remodels
            </button>
            <button type="button" className="footer-text-btn" onClick={openBathroom}>
              Bathroom Remodels
            </button>
            <button type="button" className="footer-text-btn" onClick={openLetsConnect}>
              Home Additions
            </button>
            <button type="button" className="footer-text-btn" onClick={openLetsConnect}>
              ADU&apos;s
            </button>
          </div>
        </div>
        <div>
          <div className="footer-col-title">Contact</div>
          <div className="footer-links">
            <span className="footer-inline">{COMPANY_ADDRESS_LINE}</span>
            <a href={COMPANY_PHONE_HREF}>{COMPANY_PHONE_DISPLAY}</a>
            <div className="footer-social">
              <a
                href={COMPANY_INSTAGRAM_URL}
                className="footer-social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Instagram ${COMPANY_INSTAGRAM_HANDLE}`}
              >
                <Icon icon="mdi:instagram" width={26} height={26} aria-hidden />
              </a>
              <a
                href={COMPANY_YELP_URL}
                className="footer-social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Yelp"
              >
                <Icon icon="simple-icons:yelp" width={24} height={24} aria-hidden />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p className="footer-bottom-line">
          {COMPANY_FOOTER_LICENSE_LINE} · © {new Date().getFullYear()} {COMPANY_NAME}. All
          rights reserved.
        </p>
        <div className="footer-bottom-links">
          <a href={appPath("/privacy-policy")} target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
          <a href={appPath("/terms-of-service")} target="_blank" rel="noopener noreferrer">
            Terms &amp; Conditions
          </a>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
